import { TableConfig } from '@constants/table.constants';
import { GridSortItem } from '@mui/x-data-grid-pro';
import { createStore, withProps } from '@ngneat/elf';
import { withEntities, withUIEntities } from '@ngneat/elf-entities';
import { withPagination } from '@ngneat/elf-pagination';
import { withRequestsStatus } from '@ngneat/elf-requests';
import { GlobalStatus } from '@store/common/globalStatus.enum';
import { TablePagination } from '@store/common/pagination.model';
import { Report, ReportUI, ReportsFilters } from '@store/reports/reports.model';

export interface ReportState {
  status?: GlobalStatus;
  filters: ReportsFilters;
  sort: GridSortItem;
  tablePagination: TablePagination;
}

export const reportStore = createStore(
  { name: 'reports' },
  withProps<ReportState>({
    status: undefined,
    filters: { search: '', tableFilters: ReportsFilters.initTableFilters() },
    sort: {
        field: 'report.startDate',
        sort: 'asc',
    },
    tablePagination: {
      page: 1,
      limit: TableConfig.pagination,
    },
  }),
  withEntities<Report>(),
  withUIEntities<ReportUI>(),
  withPagination(),
  withRequestsStatus(),
);
